import { Helmet } from 'react-helmet-async';
import { pageTitle } from '../../util/pageTitles';
import React from 'react';
import { withRouter } from '../../util/withRouter';
import { connect } from 'react-redux';
import _ from 'lodash';

import throttle from '../../util/throttle';
import Header from '../../components/Header/Header';
import Loading from '../../components/Loading/Loading';

import {
  handleError,
  listAll,
  getBoards,
  getLists,
  create,
  updateModel,
  isLoading,
} from '../../components/DashboardSelector/DashboardSelectorActions';
import { setPageName, isLoading as appDataIsLoading } from '../App/AppActions';

// Import Style
import './createDashboard.scss';

export class AutoConfigDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      label: '',
      boards: [],
      board: {},
      model: {},
      lists: [],
      todo: [],
      wip: [],
      done: [],
      blockedFlags: [],
      selectedBlockedFlag: '',
      selectedFields: [],
      selectedArea: '',
      wipeOut: false,
      includeChildAreas: true
    };

    this.getBoards = throttle(props.getBoards, 500, this);

    props.setDataLoading(false);
    props.dispatch(setPageName('Create dashboard'));
  }

  redirect(to) {
    global.window && window.location && window.location.replace(to);
  }

  componentDidMount() {
    if (!this.props.boards.length) {
      this.getBoards();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.user != this.props.user) {
      if (
        this.props.user.allowedDashboards > 0 &&
        this.props.user.dashboards > 0 &&
        this.props.user.dashboards >= this.props.user.allowedDashboards
      ) {
        this.props.router.replace(`/limitreached${ this.props.router.location.search || '' }`);
        return;
      }
    }

    if (this.props.created === true && prevProps.created != this.props.created) {
      this.props.loadingStart();
      this.props.listAll().then((data) => {
        this.props.loadingDone();
        this.props.setDataLoading(true);

        const dashboards =
          this.props.dashboards && this.props.dashboards.length ?
          this.props.dashboards : data;

        const last = _(dashboards)
          .orderBy('createdAt')
          .last();

        const dashboardId = this.props.params.id ? this.props.params.id : last._id;
        this.props.router.push(`/dashboard/${dashboardId}/process`);
      });
    }

    if (prevProps.dashboards != this.props.dashboards) {
      const dashboard = this.props.dashboards.find(d => d._id == this.props.params.id);
      this.props.updateModel(dashboard);
    }

    if (this.props.dashboardModel && !prevProps.dashboardModel) {
      this.props.getLists(this.props.dashboardModel.boardId, this.getOrgId());
    }

    if (this.props.outside && prevProps.boards != this.props.boards && this.props.boards.length) {
      let board = this.props.boards.find(d => d._id == this.props.plugin.boardId);

      if (!board) {
        let boardId = this.props.plugin.boardId;
        if (!boardId && this.props.dashboardModel) {
          boardId = this.props.dashboardModel.boardId;
          board = this.props.boards.find(d => d._id == boardId);
        }

        if (!board) {
          board = {
            _id: boardId,
            name: ''
          };
        }
      }

      this.handleBoardChange(board.name, board);
    }

    if (prevProps.fields !== this.props.fields) {
      const selectedFields = _(this.props.fields)
        .filter(f => {
          return f.extId !== 'members' && f.extId === 'assignees';
        })
        .map(f => f.extId)
        .value();

      this.setState({ selectedFields });
    }
  }

  componentWillReceiveProps(newProps) {
    if (newProps.fields.length && newProps.lists.length && (!this.props.lists.length || !this.props.fields.length)) {
      const lists = _.orderBy(newProps.lists, 'pos');

      const selectedFields = _(newProps.fields)
        .filter(f => {
          return f.extId !== 'members' && f.extId !== 'assignees';
        })
        .map(f => f.extId)
        .value();

      if (lists.length > 2) {
        if (
          newProps.mapping &&
          newProps.mapping.todo.length &&
          newProps.mapping.wip.length &&
          newProps.mapping.done.length
        ) {
          this.setState({
            selectedFields,
            todo: _.map(newProps.mapping.todo, _id => ({ _id })),
            wip: _.map(newProps.mapping.wip, _id => ({ _id })),
            done: _.map(newProps.mapping.done, _id => ({ _id }))
          }, () => this.handleCreate());
        } else {
          this.setState({
            selectedFields,
            todo: _.slice(lists, 0, 1),
            wip: _.slice(lists, 1, -1),
            done: _.slice(lists, -1)
          }, () => this.handleCreate());
        }
      } else {
        return this.redirect(`${window.location.origin}${window.location.pathname}${window.location.search}&configure=true${window.location.hash}`);
      }

      this.setState({
        selectedFields,
        lists: newProps.lists
      });
    }
  }

  getOrgId() {
    if (this.props.dashboardModel && this.props.dashboardModel.organization) {
      return this.props.dashboardModel.organization._id;
    }
    return '';
  }

  getListsByIds(list, ids) {
    const newList = _(list)
      .remove(obj => ids.includes(obj._id))
      .sortBy(l => {
        return ids.indexOf(l._id);
      })
      .value();
    this.setState({
      lists: list
    });
    return newList;
  }

  createDashboardModel() {
    return {
      name: this.state.name,
      label: this.state.label,
      boardId: this.state.boardId,
      board: this.state.board,
      todo: this.state.todo.map(i => i._id),
      wip: this.state.wip.map(i => i._id),
      done: this.state.done.map(i => i._id),
      selectedBlockedFlag: this.state.selectedBlockedFlag,
      selectedFields: this.state.selectedFields,
      selectedArea: this.state.selectedArea,
      wipeOut: this.state.wipeOut,
      includeChildAreas: this.state.includeChildAreas
    };
  }

  handleCreate = () => {
    const model = this.createDashboardModel();
    this.props.create(model);
  };

  handleBoardChange = (name, board) => {
    this.setState({
      name: name,
      label: name,
      boardId: board._id,
      board,
      wipeOut: false,
      lists: [],
      todo: [],
      wip: [],
      done: [],
      selectedFields: [],
    });
    this.props.getLists(board._id, board.organizationId);
  };

  render() {
    const { loadingBoards, loadingLists, saving } = this.props;

    return [
      <Header key="1" title="" />,
      <div key="2" id="create-dashboard" className='bg_dashboard'>
        <Helmet>
          <title>{pageTitle('Create dashboard')}</title>
        </Helmet>
        {(loadingBoards || loadingLists || saving) && <Loading />}
      </div>
    ];
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setError: err => dispatch(handleError(err)),
    setDataLoading: val => dispatch(appDataIsLoading(val)),
    loadingDone: () => dispatch(isLoading(false)),
    loadingStart: () => dispatch(isLoading(true)),
    listAll: () => dispatch(listAll()),
    getBoards: (value, pid, tid, projectsSkip, boardsSkip) =>
      dispatch(getBoards(value, pid, tid, projectsSkip, boardsSkip)),
    getLists: (boardId, orgId, dashboardId) => dispatch(getLists(boardId, orgId, dashboardId)),
    create: model => dispatch(create(model)),
    updateModel: dashboard => dispatch(updateModel(dashboard))
  };
};

const mapStateToProps = state => {
  return {
    app: state.app.app,
    appName: state.app.appName,
    outside: state.app.outside,
    plugin: state.app.plugin,
    user: state.auth.user,
    dashboards: state.dashboards.list,
    boards: state.dashboards.boards,
    boardsInfo: state.dashboards.boardsInfo,
    loadingBoards: state.dashboards.loadingBoards,
    lists: state.dashboards.lists,
    mapping: state.dashboards.mapping,
    fields: state.dashboards.fields,
    loadingLists: state.dashboards.loadingLists,
    created: state.dashboards.newCreated,
    dashboardModel: state.dashboards.dashboardModel,
    saving: state.dashboards.isLoading
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AutoConfigDashboard));
